export default __webpack_public_path__ + "0352a2ba935e4f6573ec630a4624b5e3.png";